<app-dialog class="reassignment-dialog" [loading]="modalLoader">
  <ng-container dialog-title>
    {{ 'module.userProfile.regionalAdmin.assignToRegionText' | translate }}
  </ng-container>
  <ng-container dialog-content>
    <div class="body">
      <div class="sub-title">Die Liste an {{ dataToMoveType }}, die neu zugeordnet werden:</div>
      <div class="container">
        <div class="label">{{ 'module.userProfile.regionalAdmin.municipalityNameText' | translate }}</div>
        <div class="source-list">
          <div *ngFor="let data of listSource; trackBy: trackByFn">{{ data.item.name }}</div>
        </div>
      </div>
      <div class="sub-title">Bitte wählen Sie die neue {{ destinationTypeName }} aus:</div>
      <div class="container">
        <div class="label label-adjusted">
          {{ 'module.userProfile.regionalAdmin.moveToText' | translate }}
        </div>
        <div class="destination-list">
          <app-list-tree
            #tree
            [data]="treeSource"
            [itemSize]="20"
            [searchPlaceholder]="'Suche'"
            [multiple]="false"
            (selectEvent)="hasSelection = true"
          ></app-list-tree>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container dialog-actions>
    <button class="btn btn-outline-primary" (click)="cancel()">
      {{ 'module.userProfile.regionalAdmin.cancelButtonText' | translate }}
    </button>
    <button class="btn btn-outline-primary" (click)="save()" [disabled]="!hasSelection">
      {{ 'module.userProfile.regionalAdmin.saveButtonText' | translate }}
    </button>
  </ng-container>
</app-dialog>
